import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';

export interface InvoiceResetConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    isOriginalExtracted: boolean;
    isLoading: boolean;
    onConfirm: () => void;
}

const InvoiceResetConfirmModal = ({
    isOpen,
    onClose,
    isOriginalExtracted,
    isLoading,
    onConfirm,
}: InvoiceResetConfirmModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Reset to original?
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.600">
                        {isOriginalExtracted
                            ? "All fields will be reverted to their original values (after automatic substitutions) and the invoice will be saved. This cannot be undone."
                            : "Clear all unsaved edits and show the last saved values."}
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="outlineGray" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }}
                            onClick={onConfirm}
                            isLoading={isLoading}
                            loadingText="Resetting..."
                        >
                            {isOriginalExtracted ? "Reset & Save" : "Clear edits"}
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceResetConfirmModal;

